export const SET_VALUE = 'SET VALUE'
export const REMOVE_VALUE = 'REMOVE VALUE'
export const RESET = 'RESET STORE'
